import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import PropTypes from 'prop-types';
import { Card, Col, Row } from 'react-bootstrap';
import MessageBox from '../../../../../Common/Message/MessageBox';
import { useGetBoardScopeElements } from '../../../../../../hooks/services/sKPI/useOfBoard';

const DialogSelectElement = (props) => {
    const { t } = useTranslation();

    const { 
        inputParam_EditMode = null,
        inputParam_ScopeId = null,
        inputParam_ElementId = null,
        inputParam_IsDialogOpen = null,
        inputParam_SetterIsDialogOpen = null,
        inputParam_SetterSelectedElementToPanel = null,
    } = props;

    const [elementList, setElementList] = useState(null);
    const [selectedElement, setSelectedElement] = useState(null);
    const [selectedTypeId, setSelectedTypeId] = useState(null);
    useGetBoardScopeElements(inputParam_ScopeId, inputParam_ElementId, elementList, setElementList)
    
    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });
    
    const onPreSelectElement = (item, typeId) => {
        setSelectedTypeId(typeId)
        setSelectedElement(item)
    }

    const onSelectElement = () => {
        inputParam_SetterSelectedElementToPanel && inputParam_SetterSelectedElementToPanel(selectedElement)
        inputParam_SetterIsDialogOpen()
    }

    const onCloseDialog = () => {
        inputParam_SetterIsDialogOpen()
    }

    const groupedElementListByType = elementList !== null ? elementList.reduce((accumulator, current) => {
        const existingGroup = accumulator.find(group => group.typeId === current.typeId);
        if (existingGroup) {
            existingGroup.l_items.push(current);
        } else {
            accumulator.push({
                typeId: current.typeId,
                type: current.type,
                l_items: [current]
            });
        }
      
        return accumulator;
    }, []) : null;
      

    return (
        <Dialog
            hidden={!inputParam_IsDialogOpen}
            onDismiss={inputParam_SetterIsDialogOpen}
            minWidth={740}
            maxWidth={1300}
            dialogContentProps={{
                type: DialogType.normal,
                styles: {header : { borderBottom: "2px solid #e8e8e8" }},
                title: t('data-lang-boxname-elements'),
            }}
            modalProps={{
                isBlocking: true,
            }}
        >
                <>
                    <Row className='pt-4'>
                        <Col style={{}}>
                            {
                                groupedElementListByType && groupedElementListByType.map(x => 
                                    <Card
                                        className='mt-2 me-1 px-1'
                                        style={{height: '150px'}} 
                                    >
                                        <Card.Header className='card-header-compact'>
                                            {t(x.type)}
                                        </Card.Header>
                                        <Card.Body style={{overflowX: "hidden", overflowY: "scroll"}}>   
                                            <Row>
                                                <Col>
                                                    {
                                                        x.l_items.map(y => 
                                                            <Row
                                                                onClick={() => onPreSelectElement(y, x.typeId)}
                                                                style={ { backgroundColor: `${(selectedElement !== null ? (y.id === selectedElement.id && selectedTypeId === x.typeId ? '#c3c3c3' : '') : '')}` } }
                                                            >
                                                                <Col>{`${y.code} ${t(y.name)}`}</Col>
                                                            </Row>
                                                        )
                                                    }
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                )
                            }
                        </Col>
                    </Row>
                    <Row>
                        <Col className="mt-2">
                            <MessageBox
                                inputParam_Message={ messageConfig.message }
                                inputParam_Display={ messageConfig.showMessage }
                                inputParam_MessageType={ messageConfig.messageType }
                                inputParam_SetterMessage={ setMessageConfig }
                            /> 
                        </Col>
                    </Row>
                </>
            <DialogFooter>
                <PrimaryButton onClick={onSelectElement} text={t('data-lang-btn-select')} />
                <DefaultButton onClick={onCloseDialog} text={t('data-lang-btn-close')} />
            </DialogFooter>
        </Dialog>
    )
};

DialogSelectElement.propTypes = {
    inputParam_EditMode: PropTypes.bool.isRequired,
    inputParam_IsDialogOpen: PropTypes.bool.isRequired,
    inputParam_SetterIsDialogOpen: PropTypes.func.isRequired,
};

export default DialogSelectElement;